<div class="table-responsive">
  <div class="card">
    <div class="card-body">

      @if (!viewMatter) {
        <div>
          <div class="row">
            <div class="col-md-6">
              <div class="button-items mt-3 mb-3" style="float: left;padding-left: 1%;">
                <h2 > Matter</h2>
              </div>
            </div>
            <div class="col-md-6">
              <div class="button-items mt-3 mb-3" style="float: right;">
                <button class="btn btn-primary btn-sm" (click)="loadMatterData(lastTableLazyLoadEvent)" pTooltip="Refresh table" appActionTooltip><i
                class="mdi mdi-reload"></i></button>
                <button class="btn btn-primary btn-sm clearBtn" (click)="dt.clear()" pTooltip="Clear all filters and sorting" appActionTooltip>Clear <i
                class="mdi mdi-filter-remove"></i></button>
              </div>
            </div>
          </div>
          <p-table #dt [lazy]="true" [columns]="cols" (onLazyLoad)="loadMatterData($event)" [value]="matterData"
            dataKey="id" styleClass="p-datatable-matter" [rowHover]="true" [rows]="10"
            [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
            responsiveLayout="scroll" [paginator]="true" [autoLayout]="true" [totalRecords]="totalRecords"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [filterDelay]="0"
            [globalFilterFields]="['orgName','name', 'number','statusCode', 'createDate']" paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th style="width:7em">
                  View @if (!disableEdit) {
                  <span>/Edit</span>
                }
              </th>
              <th pSortableColumn="name">
                <div>
                  Matter Name
                  <p-sortIcon field="name"></p-sortIcon>
                  <p-columnFilter type="text" matchMode="contains" [showOperator]="false" [matchModeOptions]="matchModeOptions"
                  [showAddButton]="false" field="name" display="menu" ></p-columnFilter>
                </div>
              </th>
              <th pSortableColumn="orgName">
                <div>
                  Organization Name
                  <p-sortIcon field="orgName"></p-sortIcon>
                  <p-columnFilter type="text" matchMode="contains" [showOperator]="false"
                    [matchModeOptions]="matchModeOptions" [showAddButton]="false"
                  field="orgName" display="menu" ></p-columnFilter>
                </div>
              </th>
              <th>
                <div>
                  QuickBook Id
                  <!-- <p-sortIcon field="quickbookId"></p-sortIcon>
                  <p-columnFilter type="text" [showOperator]="false"
                    [matchModeOptions]="matchModeOptions" [showAddButton]="false" field="quickbookId"
                  display="menu" ></p-columnFilter> -->
                </div>
              </th>
              <th pSortableColumn="number">
                <div>
                  Matter Number
                  <p-sortIcon field="number"></p-sortIcon>
                  <p-columnFilter type="text" matchMode="contains" field="number" display="menu" [showMatchModes]="true"
                    [showOperator]="false" [matchModeOptions]="matchModeOptions"
                  [showAddButton]="false" ></p-columnFilter>
                </div>
              </th>
              <th pSortableColumn="statusCode">
                <div>
                  Status
                  <p-sortIcon field="statusCode"></p-sortIcon>
                  <p-columnFilter field="statusCode" matchMode="equals" [showMatchModes]="true"
                    [showOperator]="false" [showAddButton]="false" display="menu" >
                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                      <p-dropdown [ngModel]="value" [options]="statuses"
                        (onChange)="filter($event.value)" placeholder="Any">
                        <ng-template let-option pTemplate="item">
                          <span
                          [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                        </ng-template>
                      </p-dropdown>
                    </ng-template>
                  </p-columnFilter>
                </div>
              </th>
              <th pSortableColumn='createDate'>
                <div>
                  Date Created
                  <p-sortIcon field="createDate"></p-sortIcon>
                  <p-columnFilter type="date" field="createDate" [showMatchModes]="true"
                    [showOperator]="false" [matchModeOptions]="matchModeOptionsDate"
                  [showAddButton]="false" display="menu" ></p-columnFilter>
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-matterData let-columns="cols">
            <tr>
              <td>
                <div >
                  <a class="btn btn-info btn-sm mr-2" (click)="editMatter(true,matterData)"
                    role="button" pTooltip="View matter" appActionTooltip><i class="mdi mdi-eye"></i></a>
                    @if (!disableEdit) {
                      <a class="btn btn-warning btn-sm" (click)="editMatter(false,matterData)"
                        role="button" pTooltip="Edit matter" appActionTooltip><i class="mdi mdi-pencil"></i></a>
                      }
                    </div>
                  </td>
                  @for (col of cols; track col) {
                    <td>
                      @if (col.field=='name') {
                        <span>
                          <a href="javascript:void(0);" style="cursor:pointer !important"
                            (click)="clicked(matterData)" pTooltip="Open matter details" appActionTooltip> {{col.data ?
                          (matterData[col.field]| date : col.format) : matterData[col.field]}}</a>
                        </span>
                      }
                      @if (col.field!='name') {
                        <span>
                          {{col.data ? (matterData[col.field]| date : col.format) : matterData[col.field]}}
                        </span>
                      }
                    </td>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns && columns.length">
                    No records found
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        }
        @if (viewMatter) {
          <div>
            <div class="row">
              <div class="col-md-6">
                <div class="button-items mt-3 mb-3" style="float: left;padding-left: 1%;">
                  <h2 > {{viewMatterName}}</h2>
                </div>
              </div>
              <div class="col-md-6">
                <div class="button-items" style="float: right;">
                  <a class="btn btn-primary btn-sm" (click)="backToMatterGrid()" role="button" pTooltip="Back to matters list" appActionTooltip>Back</a>
                </div>
              </div>
            </div>
            <p-tabView [cache]="false">
              <p-tabPanel header="Details">
                <app-view-matter [viewMatter]="viewMatter" [viewOnly]="viewOnly" [selectedRow]="selectedRow" (closeFlag)="closeDialog($event)"></app-view-matter>
              </p-tabPanel>
              <p-tabPanel header="Projects" >
                <app-projects-grid [projectMatterFilter]="projectMatterFilter"></app-projects-grid>
              </p-tabPanel>
              <!-- <p-tabPanel header="Users">
              <app-users-grid></app-users-grid>
            </p-tabPanel> -->
          </p-tabView>
        </div>
      }

    </div>
  </div>
</div>

<p-dialog [resizable]="false" [draggable]="false" (onHide)="closeDialog()" [(visible)]="matterDialog"
  [style]="{width: '80%'}" [header]="title" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">

    <app-view-matter [viewMatter]="viewMatter" [viewOnly]="viewOnly" [selectedRow]="selectedRow" (closeFlag)="closeDialog($event)"></app-view-matter>

  </ng-template>
</p-dialog>